/* global glide */
(function ($, Drupal) {
    'use strict';

    Drupal.behaviors.cardShortSlider = {
        attach: function (context) {
            let options = {
                type: 'carousel',
                animationDuration: 300,
                perView: 2,
                gap: 80,
                animationTimingFunc: 'ease-in',
                peek: {
                    before: 0,
                    after: 200
                },
                breakpoints: {
                    1280: {
                        gap: 50,
                    },
                    990: {
                        gap:40,
                        perView: 1
                    },
                    767: {
                        peek: {
                            before: 0,
                            after: 0
                        },
                        perView: 1
                    }
                }
            };

            let check_resize = (glide, carousel) => {
                glide.slides_count = carousel.querySelectorAll('.glide__slide');

                glide.slides_count = Object.values(glide.slides_count).filter(function (slide) {
                    if (!slide.classList.contains('glide__slide--clone')) {
                        return slide;
                    }
                }).length;

                if (glide.slides_count <= glide.settings.perView) {
                    glide.update({startAt: 0}).disable();
                    carousel.classList.remove('glide--active');
                }
                else {
                    glide.enable();
                    carousel.classList.add('glide--active');
                }
            };

            let carousels = context.querySelectorAll('.js-card-short-slider .glide');
            Object.values(carousels).map(function (carousel) {

                let glide = new Glide(carousel, options);

                glide.on('resize', () => {
                    check_resize(glide, carousel);
                });

                glide.mount();

                check_resize(glide, carousel);
            });
        }
    };
}(jQuery, Drupal));